/**
 *  @shelf-version: 1.0.0
 */

import History from './history'

export default History
